import React, { useState, useEffect, useCallback } from 'react';
import Navbar from '../components/Navbar';
import QuotationFormModal from '../components/QuotationFormModal';
import './CadastroFornecedores.css';

const CadastroFornecedores = () => {
    const [suppliers, setSuppliers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [criteria, setCriteria] = useState({
        NomeEmpresa: true,
        Endereco: false,
        Telefone: false,
        Email: false,
        Observacao: false
    });
    const [currentIdx, setCurrentIdx] = useState(null);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        NomeEmpresa: '',
        Endereco: '',
        Telefone: '',
        Email: '',
        Observacao: '',
        ChavePix: '',
        CPF_CNPJ: ''
    });
    const [isCotacaoModalOpen, setIsCotacaoModalOpen] = useState(false);
    const [quotationHistory, setQuotationHistory] = useState([]);
    const [editingCotId, setEditingCotId] = useState(null);

    const fetchSuppliers = useCallback(async () => {
        setLoading(true);
        try {
            const selectedFields = Object.keys(criteria).filter(key => criteria[key]).join(',');
            let url = '/api/fornecedores';
            if (searchTerm && selectedFields) {
                url += `?search=${encodeURIComponent(searchTerm)}&fields=${encodeURIComponent(selectedFields)}`;
            }
            const res = await fetch(url, { credentials: 'include' });
            const data = await res.json();
            setSuppliers(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error('Erro ao buscar fornecedores:', error);
        } finally {
            setLoading(false);
        }
    }, [searchTerm, criteria]);

    const fetchQuotationHistory = async (supplierId) => {
        try {
            const res = await fetch(`/api/cotacoes?IDFornecedor=${supplierId}`, { credentials: 'include' });
            if (res.ok) setQuotationHistory(await res.json());
        } catch (error) {
            console.error('Erro ao buscar histórico:', error);
        }
    };

    useEffect(() => {
        const fetchUser = async () => {
            const res = await fetch('/api/auth/me', { credentials: 'include' });
            if (res.ok) {
                const data = await res.json();
                setUser(data.user);
            }
        };
        fetchUser();
        fetchSuppliers();
    }, [fetchSuppliers]);

    const handleSearchClick = () => {
        fetchSuppliers();
    };

    const selectSupplier = (index) => {
        const sup = suppliers[index];
        setCurrentIdx(index);
        setQuotationHistory([]); // Clear previous history while loading new one
        setFormData({
            NomeEmpresa: sup.NomeEmpresa || '',
            Endereco: sup.Endereco || '',
            Telefone: sup.Telefone || '',
            Email: sup.Email || '',
            Observacao: sup.Observacao || '',
            ChavePix: sup.ChavePix || '',
            CPF_CNPJ: sup.CPF_CNPJ || ''
        });
        fetchQuotationHistory(sup.ID);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };


    const handleSave = async (e) => {
        e.preventDefault();
        const sup = suppliers[currentIdx];
        try {
            const res = await fetch(`/api/fornecedores/${sup.ID}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
                credentials: 'include'
            });
            if (res.ok) {
                alert('Fornecedor atualizado com sucesso!');
                fetchSuppliers();
            } else {
                alert('Erro ao salvar alterações.');
            }
        } catch (error) {
            console.error('Erro ao salvar:', error);
        }
    };

    const createNewSupplier = async () => {
        try {
            const res = await fetch('/api/fornecedores', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    NomeEmpresa: 'Novo Fornecedor',
                    Endereco: '',
                    Telefone: '',
                    Email: '',
                    Observacao: '',
                    ChavePix: '',
                    CPF_CNPJ: ''
                }),
                credentials: 'include'
            });
            if (res.ok) {
                alert('Novo fornecedor criado!');
                fetchSuppliers();
            } else {
                alert('Erro ao criar fornecedor.');
            }
        } catch (error) {
            console.error('Erro ao criar:', error);
        }
    };

    const handleDelete = async () => {
        if (!window.confirm('Tem certeza que deseja excluir este fornecedor?')) return;
        const sup = suppliers[currentIdx];
        try {
            const res = await fetch(`/api/fornecedores/${sup.ID}`, {
                method: 'DELETE',
                credentials: 'include'
            });
            if (res.ok) {
                alert('Fornecedor excluído com sucesso!');
                setCurrentIdx(null);
                setQuotationHistory([]);
                fetchSuppliers();
            } else {
                alert('Erro ao excluir fornecedor.');
            }
        } catch (error) {
            console.error('Erro ao excluir:', error);
        }
    };

    const handleDeleteQuotation = async (id) => {
        if (!window.confirm(`Tem certeza que deseja excluir a cotação #${id}?`)) return;

        try {
            const res = await fetch(`/api/cotacoes/${id}`, {
                method: 'DELETE',
                credentials: 'include'
            });

            if (res.ok) {
                alert('Cotação excluída com sucesso!');
                fetchQuotationHistory(suppliers[currentIdx].ID);
            } else {
                const data = await res.json();
                alert(data.message || 'Erro ao excluir cotação.');
            }
        } catch (err) {
            console.error('Erro ao excluir:', err);
            alert('Erro de conexão ao excluir cotação.');
        }
    };

    // Unified handleFormSuccess
    const handleFormSuccess = () => {
        closeCotacaoModal();
    };

    const handleVerifyQuotation = async (id) => {
        if (!window.confirm('Deseja marcar esta cotação como Verificada? Isso irá bloqueá-la para o fornecedor.')) return;
        try {
            const res = await fetch(`/api/cotacoes/${id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ status: 'Verificada' }),
                credentials: 'include'
            });
            if (res.ok) {
                alert('Cotação marcada como Verificada!');
                // Removed navigate('/cotacoes'); as it's handled by the modal's onSuccess
            }
        } catch (error) {
            console.error('Erro ao verificar cotação:', error);
        }
    };

    const openCotacaoModal = () => {
        setEditingCotId(null);
        setIsCotacaoModalOpen(true);
    };

    const closeCotacaoModal = () => {
        setIsCotacaoModalOpen(false);
        setEditingCotId(null);
        if (currentIdx !== null) fetchQuotationHistory(suppliers[currentIdx].ID);
    };

    const editHistoryQuotation = (id) => {
        setEditingCotId(id);
        setIsCotacaoModalOpen(true);
    };

    return (
        <div className="cadastro-fornecedores-container">
            <Navbar user={user} />

            <div className="sup-layout">
                <aside className="sup-sidebar">
                    <div className="sidebar-header">
                        <h2>Fornecedores</h2>
                        <button className="btn-new-sup" onClick={createNewSupplier}>+ Novo</button>
                    </div>

                    <div className="search-section">
                        <div className="search-input-group">
                            <input
                                type="text"
                                placeholder="Termo de pesquisa..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                onKeyDown={(e) => e.key === 'Enter' && fetchSuppliers()}
                            />
                            <button onClick={handleSearchClick}>🔍</button>
                        </div>
                        <div className="criteria-group">
                            <label><input type="radio" name="supSearchCriteria" checked={criteria.NomeEmpresa} onChange={() => setCriteria({ NomeEmpresa: true, Endereco: false, Telefone: false, Email: false, Observacao: false })} /> Nome</label>
                            <label><input type="radio" name="supSearchCriteria" checked={criteria.Endereco} onChange={() => setCriteria({ NomeEmpresa: false, Endereco: true, Telefone: false, Email: false, Observacao: false })} /> Endereço</label>
                            <label><input type="radio" name="supSearchCriteria" checked={criteria.Telefone} onChange={() => setCriteria({ NomeEmpresa: false, Endereco: false, Telefone: true, Email: false, Observacao: false })} /> Tel</label>
                            <label><input type="radio" name="supSearchCriteria" checked={criteria.Email} onChange={() => setCriteria({ NomeEmpresa: false, Endereco: false, Telefone: false, Email: true, Observacao: false })} /> Email</label>
                            <label><input type="radio" name="supSearchCriteria" checked={criteria.Observacao} onChange={() => setCriteria({ NomeEmpresa: false, Endereco: false, Telefone: false, Email: false, Observacao: true })} /> Obs</label>
                        </div>
                    </div>

                    <div className="sup-list">
                        {loading ? (
                            <p className="loading-text">Carregando...</p>
                        ) : suppliers.length > 0 ? (
                            suppliers.map((sup, index) => (
                                <div
                                    key={sup.ID}
                                    className={`sup-item ${currentIdx === index ? 'active' : ''}`}
                                    onClick={() => selectSupplier(index)}
                                >
                                    <strong>{sup.NomeEmpresa}</strong>
                                    <span>{sup.Telefone || 'Sem telefone'}</span>
                                </div>
                            ))
                        ) : (
                            <p className="empty-list">Nenhum fornecedor encontrado.</p>
                        )}
                    </div>
                </aside>

                <main className="sup-content">
                    {currentIdx !== null ? (
                        <div className="sup-details-view">
                            <form onSubmit={handleSave} className="sup-form-window">
                                <div className="win-title">
                                    Ficha do Fornecedor #{suppliers[currentIdx].ID}
                                </div>

                                <div className="win-body">

                                    <div className="form-group">
                                        <label>Nome da Empresa / Razão Social</label>
                                        <input type="text" name="NomeEmpresa" value={formData.NomeEmpresa} onChange={handleInputChange} required />
                                    </div>

                                    <div className="form-grid">
                                        <div className="form-group">
                                            <label>Endereço Completo</label>
                                            <input type="text" name="Endereco" value={formData.Endereco} onChange={handleInputChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>CPF / CNPJ</label>
                                            <input type="text" name="CPF_CNPJ" value={formData.CPF_CNPJ} onChange={handleInputChange} placeholder="00.000.000/0000-00" />
                                        </div>
                                        <div className="form-group">
                                            <label>Telefone</label>
                                            <input type="text" name="Telefone" value={formData.Telefone} onChange={handleInputChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Email</label>
                                            <input type="email" name="Email" value={formData.Email} onChange={handleInputChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Chave PIX</label>
                                            <input type="text" name="ChavePix" value={formData.ChavePix} onChange={handleInputChange} placeholder="Ex: CPF, Email, Aleatória..." />
                                            <small className="form-warning">Favor confirmar se a chave está correta ou atualizada na hora do pagamento.</small>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label>Observação</label>
                                        <textarea name="Observacao" rows="4" value={formData.Observacao} onChange={handleInputChange}></textarea>
                                    </div>

                                    <div className="form-actions">
                                        <button type="submit" className="btn-classic primary">Salvar Alterações</button>
                                        <button type="button" className="btn-classic" onClick={openCotacaoModal}>Solicitar Cotação</button>
                                        <button type="button" className="btn-classic danger" onClick={handleDelete}>Excluir Fornecedor</button>
                                    </div>
                                </div>
                            </form>

                            <div className="quotation-history-card">
                                <h3>Histórico de Cotações</h3>
                                <div className="history-list">
                                    {quotationHistory.length > 0 ? quotationHistory.map(q => (
                                        <div key={q.ID} className={`history-item ${q.Status.toLowerCase()}`}>
                                            <div className="h-left">
                                                <strong>
                                                    #{q.ID} - {q.Descricao || '(Sem nome)'}
                                                    {q.idPedidoOrigem && ` (Orçamento #${q.idPedidoOrigem})`}
                                                    {` - ${q.Status}`}
                                                </strong>
                                                <span>{new Date(q.DataCotacao).toLocaleDateString('pt-BR')}</span>
                                            </div>
                                            <div className="h-right">
                                                <span>{q.DuracaoDias} dias</span>
                                                <button className="btn-tiny" onClick={() => editHistoryQuotation(q.ID)}>
                                                    {q.Status.toLowerCase() === 'rascunho' || q.Status.toLowerCase() === 'pendente' ? 'Editar' : 'Detalhes'}
                                                </button>
                                                {q.Status.toLowerCase() === 'enviada' && (
                                                    <button className="btn-tiny primary" onClick={() => handleVerifyQuotation(q.ID)}>Verificar</button>
                                                )}
                                                <button className="btn-tiny danger" style={{ marginLeft: '4px' }} onClick={() => handleDeleteQuotation(q.ID)}>Excluir</button>
                                            </div>
                                        </div>
                                    )) : <p>Nenhuma cotação recente.</p>}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="sup-empty-state">
                            <p>Selecione um fornecedor na lista à esquerda para ver os detalhes ou clique em "+ Novo".</p>
                        </div>
                    )}
                </main>

                {isCotacaoModalOpen && (
                    <QuotationFormModal
                        supplier={suppliers[currentIdx]}
                        quotationId={editingCotId}
                        onClose={closeCotacaoModal}
                        onSuccess={handleFormSuccess}
                    />
                )}
            </div>
        </div>
    );
};

export default CadastroFornecedores;
